// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { IBandsEx } from './iBandsEx';
export const iBands = 'iBands';
export class IBands extends IBandsEx {
    constructor(maPeriod, maMode, deviation, bandsShift) {
        super(maPeriod, maMode, deviation, bandsShift, PriceType.Close);
    }
    get Name() {
        return iBands;
    }
}
